/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Modal, Input } from 'antd';

import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

import api from '~/services/api';

import { store } from '~/store';

import history from '~/services/history';

import {
  Container,
  ContainerAlerta,
} from '../ModalReenviarLinhaDeCuidado/styles';

import { ContainerConfirmPassword } from './style';

import iconAlertConfirm from '~/assets/icons/iconAlertConfirm.svg';

import { catchErros } from '~/pages/LinhasDeCuidado/messages';

export default function ModalAlertaExcluirLinhaCuidado({
  deletarLinha,
  setDeletarLinha,
  data,
}) {
  const { token } = store.getState().auth;
  const [senha, setSenha] = useState(false);

  const deleteLinhaCuidado = async () => {
    setDeletarLinha(false);
    try {
      const response = await api.delete(
        `indicadores-linhas-de-cuidado/${data.linhaDeCuidadoValue}/formulario-eletronico/${data.id}`,
        {
          headers: {
            Authorization: token,
          },
          data: senha,
        }
      );

      Swal.fire({
        title: 'Obrigado!',
        text: `${String(response.data.menssagem)}`,
        icon: 'success',
        confirmButtonColor: '#74a50a',
        confirmButtonText: 'Ok! Obrigado!',
      }).then(() => {
        history.push({
          pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
          state: {
            periodo: data.periodoSelecionado,
          },
        });
        window.location.reload();
      });
    } catch (error) {
      history.push({
        pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
        state: {
          periodo: data.periodoSelecionado,
        },
      });
      catchErros(error);
    }
  };

  function confirmaSenha() {
    if (!senha) {
      toast.warn('Digite sua senha para continuar.', {
        autoClose: 7000,
      });

      return;
    }

    deleteLinhaCuidado();
  }

  return (
    <Container>
      <Modal
        visible={deletarLinha}
        onOk={() => {}}
        onCancel={() => setDeletarLinha(false)}
        centered
        footer={null}
        width="480px"
      >
        <ContainerAlerta>
          <img src={iconAlertConfirm} alt="Confirma reenvio" />
          <h3 style={{ fontSize: '24px' }}>
            Tem certeza de que deseja
            <br /> excluir o registro?
          </h3>

          <ContainerConfirmPassword>
            <h4>Essa ação não poderá ser desfeita.</h4>

            <div className="confirmSenha">
              <span>Confirme sua senha para excluir registro:</span>
            </div>

            <div className="confirmInputSenha">
              <Input.Password
                placeholder="Digite sua senha"
                onChange={e => setSenha(e.target.value)}
              />
            </div>
          </ContainerConfirmPassword>

          <div className="buttonActions">
            <button type="button" onClick={confirmaSenha}>
              Prosseguir
            </button>
            <button
              type="button"
              className="buttonCancel"
              onClick={() => setDeletarLinha(false)}
            >
              Cancelar
            </button>
          </div>
        </ContainerAlerta>
      </Modal>
    </Container>
  );
}
